import React, {useEffect, useRef} from 'react';
import {Button, DatePicker, Descriptions, Form, Input, InputNumber, Modal, Select, Spin, Table, message, Space} from 'antd';
import {updatecwsrdj, getcwsrdj} from "../../lib/api_cw_srdj";
import {getDetail, getImageProxy} from "../../lib/api_cw_zcfkd";
import moment from "moment";
import styles from './zcfkd_modal.module.css';
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';

/**
 * 付款单弹窗
 * @param onCancel
 * @param onOk
 * @returns {JSX.Element}
 * @constructor
 */
const ZcfkdEditModal = ({id, onCancel, onOk}) => {
    const [loading, setLoading] = React.useState(false);
    const [exportLoading, setExportLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const printContentRef = useRef(null);

    const fetchData = () => {
        setLoading(true)
        getDetail(id)
            .then(res => {
                if (res.code === 0) {
                    setData(res.data);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(fetchData, [id]);

    const handleOk = () => {
        onOk && onOk();
    }
    const handleCancel = () => {
        onCancel && onCancel();
    }

    const handlePrint = () => {
        if (printContentRef.current) {
            // 创建一个包含原始类名的打印内容
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
      <html>
        <head>
          <title>打印内容</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              font-size: 16px; /* 所有字号加大2号 */
            }
            .print-container {
              max-width: 800px;
              margin: 0 auto;
            }
            .print-title {
              text-align: center;
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .print-info {
              margin: 15px 0;
              padding: 10px;
              background-color: #f9f9f9;
              border: 1px solid #ddd;
              border-radius: 3px;
            }
            .print-info div {
              margin: 5px 0;
            }
            .print-amount {
              font-size: 20px;
              font-weight: bold;
              color: #e74c3c;
            }
            .account-info {
              margin: 15px 0;
              padding: 10px;
              border: 1px solid #ddd;
              border-radius: 3px;
              background-color: #f9f9f9;
            }
            .account-info-item {
              margin: 5px 0;
            }
            .print-table {
              width: 100%;
              border-collapse: collapse;
              margin: 20px 0;
              background-color: #fff;
            }
            .print-table th,
            .print-table td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
            }
            .print-table th {
              background-color: #f5f5f5;
              font-weight: bold;
            }
            .print-table tbody tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            .signature-section {
              display: flex;
              justify-content: space-between;
              margin-top: 40px;
              font-size: 18px;
            }
            .signature-line {
              border-bottom: 1px solid #000;
              width: 200px;
              margin-left: 10px;
              display: inline-block;
              height: 20px;
              vertical-align: middle;
            }
            .manager-signature-line {
              border-bottom: 1px solid #000;
              width: 300px;
              margin-left: 10px;
              display: inline-block;
              height: 20px;
              vertical-align: middle;
            }
          </style>
        </head>
        <body>
          <div class="print-container">
            <div class="print-title">合并付款单${data.id ? `<div style="font-size: 18px; display: inline-block;">（${data.id}）</div>` : ''}</div>
            ${data.sub_title ? `<div style="text-align: center; font-size: 18px; margin-bottom: 20px;">${data.sub_title}</div>` : ''}
            <div class="print-info">
              <div>创建日期: ${data.cjsj ? moment(data.cjsj).format('YYYY-MM-DD') : ''}</div>
              <div>付款金额: <span class="print-amount">${data.hjje || ''}</span></div>
              <div>笔数: ${data.bishu || ''}</div>
            </div>
            <div class="account-info">
              <div class="account-info-item">收款账户信息</div>
              <div class="account-info-item">户名: ${data.huhao || ''}</div>
              <div class="account-info-item">账号: ${data.zhanghao || ''}</div>
              <div class="account-info-item">开户行: ${data.kaihuhang || ''}</div>
            </div>
            <table class="print-table">
              <thead>
                <tr>
                  <th>审批编号</th>
                  <th style="width: 150px;">来源</th>
                  <th style="width: 120px;">支付方式</th>
                  <th>金额</th>
                  <th>事由</th>
                </tr>
              </thead>
              <tbody>
                ${data.zcdjs && data.zcdjs.map(item => `
                <tr>
                  <td>${item.sp_no || ''}</td>
                  <td>${item.ly || ''}</td>
                  <td>${item.zcfs || ''}</td>
                  <td>${item.je || ''}</td>
                  <td>${item.bz || ''}</td>
                </tr>
                `).join('')}
              </tbody>
            </table>
            <div class="signature-section">
              <div>
                制单人: <span class="signature-line"></span>
              </div>
              <div>
                总经理: <span class="manager-signature-line"></span>
              </div>
            </div>
          </div>
        </body>
      </html>
    `);
            printWindow.document.close();
            printWindow.focus();
            // 延迟执行打印，确保内容已加载
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        }
    };

    // 使用代理接口将图片 URL 转换为 base64（避免 CORS 问题）
    const fetchImageAsBase64 = async (url) => {
        try {
            console.log('开始获取图片:', url);
            const response = await getImageProxy(url);
            console.log('响应:', response);
            console.log('响应类型:', typeof response);
            
            // 尝试获取 blob 数据
            let blob;
            if (response.data && response.data instanceof Blob) {
                blob = response.data;
            } else if (response instanceof Blob) {
                blob = response;
            } else {
                console.log('无法获取 Blob 数据，尝试其他方式');
                return null;
            }
            
            console.log('blob:', blob);
            console.log('blob.type:', blob.type);
            
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = function() {
                    console.log('reader.result:', reader.result);
                    resolve(reader.result);
                };
                reader.onerror = function(error) {
                    console.error('FileReader error:', error);
                    resolve(null);
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('获取图片失败:', error);
            return null;
        }
    };

    // 导出 Excel
    const exportToExcel = async () => {
        setExportLoading(true);
        try {
            message.loading({ content: '正在导出...', key: 'export' });
            
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('合并付款单');

            // 设置列宽
            worksheet.getColumn(1).width = 20;
            worksheet.getColumn(2).width = 25;
            worksheet.getColumn(3).width = 15;
            worksheet.getColumn(4).width = 15;
            worksheet.getColumn(5).width = 30;
            // 为更多图片设置列宽
            for (let i = 6; i <= 15; i++) {
                worksheet.getColumn(i).width = 15;
            }

            // 标题行
            worksheet.mergeCells('A1:F1');
            const titleCell = worksheet.getCell('A1');
            titleCell.value = `合并付款单${data.id ? `（${data.id}）` : ''}`;
            titleCell.font = { size: 18, bold: true };
            titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

            // 副标题
            if (data.sub_title) {
                worksheet.mergeCells('A2:F2');
                const subTitleCell = worksheet.getCell('A2');
                subTitleCell.value = data.sub_title;
                subTitleCell.font = { size: 14 };
                subTitleCell.alignment = { horizontal: 'center', vertical: 'middle' };
            }

            // 基本信息
            let currentRow = data.sub_title ? 4 : 3;
            worksheet.getCell(`A${currentRow}`).value = '创建日期:';
            worksheet.getCell(`B${currentRow}`).value = data.cjsj ? moment(data.cjsj).format('YYYY-MM-DD') : '';
            currentRow++;
            
            worksheet.getCell(`A${currentRow}`).value = '付款金额:';
            worksheet.getCell(`B${currentRow}`).value = data.hjje || '';
            worksheet.getCell(`B${currentRow}`).font = { color: { argb: 'FF0000' }, bold: true };
            currentRow++;
            
            worksheet.getCell(`A${currentRow}`).value = '笔数:';
            worksheet.getCell(`B${currentRow}`).value = data.bishu ? `${data.bishu}笔` : '';
            currentRow++;
            
            worksheet.getCell(`A${currentRow}`).value = '户名:';
            worksheet.getCell(`B${currentRow}`).value = data.huhao || '';
            currentRow++;
            
            worksheet.getCell(`A${currentRow}`).value = '账号:';
            worksheet.getCell(`B${currentRow}`).value = data.zhanghao || '';
            currentRow++;
            
            worksheet.getCell(`A${currentRow}`).value = '开户行:';
            worksheet.getCell(`B${currentRow}`).value = data.kaihuhang || '';
            currentRow += 2;

            // 表头
            const headerRow = worksheet.getRow(currentRow);
            headerRow.values = ['审批编号', '来源', '支付方式', '金额', '事由', '付款截屏'];
            headerRow.font = { bold: true };
            headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f5f5f5' } };
            headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
            headerRow.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };

            currentRow++;

            // 数据行
            if (data.zcdjs && data.zcdjs.length > 0) {
                for (const item of data.zcdjs) {
                    const row = worksheet.getRow(currentRow);
                    row.getCell(1).value = item.sp_no || '';
                    row.getCell(2).value = item.ly || '';
                    row.getCell(3).value = item.zcfs || '';
                    row.getCell(4).value = item.je || '';
                    row.getCell(5).value = item.bz || '';
                    
                    // 添加付款截屏图片
                    if (item.images) {
                        try {
                            console.log('item.images:', item.images);
                            let imageList;
                            if (Array.isArray(item.images)) {
                                imageList = item.images;
                            } else {
                                imageList = JSON.parse(item.images);
                            }
                            console.log('imageList:', imageList);
                            
                            if (Array.isArray(imageList) && imageList.length > 0) {
                                // 加载所有图片
                                let imagePositions = [];
                                
                                for (let i = 0; i < imageList.length; i++) {
                                    const imgUrl = imageList[i];
                                    console.log('imgUrl:', imgUrl);
                                    
                                    const base64 = await fetchImageAsBase64(imgUrl);
                                    console.log('base64:', base64 ? 'success' : 'null');
                                    
                                    if (base64) {
                                        // 获取图片扩展名
                                        let extension = 'jpeg';
                                        if (imgUrl.toLowerCase().endsWith('.png')) extension = 'png';
                                        else if (imgUrl.toLowerCase().endsWith('.gif')) extension = 'gif';
                                        else if (imgUrl.toLowerCase().endsWith('.bmp')) extension = 'bmp';
                                        
                                        console.log('extension:', extension);
                                        
                                        const imageId = workbook.addImage({
                                            base64: base64,
                                            extension: extension,
                                        });
                                        
                                        imagePositions.push({
                                            imageId: imageId,
                                            col: 5 + i, // 横向排列
                                        });
                                    } else {
                                        // 图片加载失败，显示链接
                                        const cell = row.getCell(6 + i);
                                        cell.value = {
                                            text: imgUrl,
                                            hyperlink: imgUrl
                                        };
                                        cell.font = { color: { argb: 'FF0000FF' }, underline: true };
                                    }
                                }
                                
                                // 设置行高
                                if (imagePositions.length > 0) {
                                    row.height = 80;
                                    
                                    // 添加所有图片
                                    for (let pos of imagePositions) {
                                        worksheet.addImage(pos.imageId, {
                                            tl: { col: pos.col, row: currentRow - 1 },
                                            ext: { width: 100, height: 70 },
                                        });
                                    }
                                }
                            }
                        } catch (e) {
                            console.error('解析图片失败:', e);
                            row.getCell(6).value = '解析失败: ' + (e.message || '');
                        }
                    }
                    
                    // 设置边框
                    row.eachCell((cell, colNumber) => {
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                        if (colNumber !== 6) {
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        }
                    });
                    
                    currentRow++;
                }
            }

            // 导出 Excel
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `合并付款单${data.id ? `_${data.id}` : ''}_${moment().format('YYYYMMDDHHmmss')}.xlsx`);
            
            message.success({ content: '导出成功', key: 'export' });
        } catch (error) {
            console.error('导出失败:', error);
            message.error({ content: '导出失败', key: 'export' });
        } finally {
            setExportLoading(false);
        }
    };

    return (
        <Modal
            title="付款单详情"
            open={true}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
            width={1000}
            footer={false}
            style={{top: 20}}
        >
            {/*打印和导出按钮*/}
            <Space>
                <Button type="primary" onClick={handlePrint}>打印</Button>
                <Button type="default" onClick={exportToExcel} loading={exportLoading}>导出 Excel</Button>
            </Space>
            <Spin spinning={loading}>
                <div ref={printContentRef}>
                    <div className={styles['print-title']}>
                      合并付款单
                      {data.id && (
                        <div style={{ fontSize: '18px', display: 'inline-block' }}>（{data.id}）</div>
                      )}
                    </div>
                    {data.sub_title && (
                        <div style={{ textAlign: 'center', fontSize: '18px', marginBottom: '20px' }}>
                            {data.sub_title}
                        </div>
                    )}
                    <div className={styles['print-info']}>
                        <div>创建日期: {data.cjsj ? moment(data.cjsj).format('YYYY-MM-DD') : ''}</div>
                        <div>付款金额: <span className={styles['print-amount']}>{data.hjje || ''}</span></div>
                        <div>笔数: {data.bishu || ''}</div>
                    </div>
                    <div className={styles['account-info']}>
                        <div className={styles['account-info-item']}>收款账户信息</div>
                        <div className={styles['account-info-item']}>户名: {data.huhao || ''}</div>
                        <div className={styles['account-info-item']}>账号: {data.zhanghao || ''}</div>
                        <div className={styles['account-info-item']}>开户行: {data.kaihuhang || ''}</div>
                    </div>
                    <table className={styles['print-table']}>
                        <thead>
                            <tr>
                                <th>审批编号</th>
                                <th style={{width: '150px'}}>来源</th>
                                <th style={{width: '120px'}}>支付方式</th>
                                <th>金额</th>
                                <th>事由</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.zcdjs && data.zcdjs.map(item => (
                                <tr key={item.id}>
                                    <td>{item.sp_no || ''}</td>
                                    <td>{item.ly || ''}</td>
                                    <td>{item.zcfs || ''}</td>
                                    <td>{item.je || ''}</td>
                                    <td>{item.bz || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className={styles['signature-section']}>
                        <div>
                            制单人: <span className={styles['signature-line']}></span>
                        </div>
                        <div>
                            总经理: <span className={styles['manager-signature-line']}></span>
                        </div>
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}

export default ZcfkdEditModal;